export default "__VITE_ASSET__DnLqVxDh__"